// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"7196":"3b53517f","7406":"3b53517f","7780":"664aa362","8514":"3b53517f"}[chunkId] + ".chunk.css");